import React, { useEffect, useState } from 'react';

const API_BASE = 'https://referee-roster-api-v2-hqghffesdfegd2dq.australiaeast-01.azurewebsites.net/api';
const CATEGORY_COLOURS = {
  Competition: { bg: '#e6effd', fg: '#2a5fc4' },
  Program: { bg: '#e3f4ea', fg: '#1b7a43' },
  Trial: { bg: '#fde8f4', fg: '#b0287a' },
  Other: { bg: '#eeeef0', fg: '#48484f' },
};

// A participant's Basketball Connect registrations (read-only; they come
// from the Basketball Connect sync).
export default function ParticipantRegistrations({ participantId }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!participantId) return;
    let cancelled = false;
    setRows(null);
    fetch(`${API_BASE}/participants/${participantId}/registrations`)
      .then(async (r) => {
        const data = await r.json().catch(() => []);
        if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
        return data;
      })
      .then((data) => { if (!cancelled) setRows(Array.isArray(data) ? data : []); })
      .catch((e) => { if (!cancelled) setError(e.message); });
    return () => { cancelled = true; };
  }, [participantId]);

  return (
    <div className="form-group" style={{ gridColumn: '1 / -1' }}>
      <label>Basketball Connect registrations</label>
      {error && <div style={{ color: '#c62828', fontSize: '0.85rem' }}>{error}</div>}
      {!error && rows === null && <div style={{ color: '#888', fontSize: '0.85rem' }}>Loading…</div>}
      {rows && rows.length === 0 && (
        <div style={{ color: '#888', fontSize: '0.85rem' }}>No Basketball Connect registrations recorded for this player this year.</div>
      )}
      {rows && rows.length > 0 && (
        <div style={{ overflowX: 'auto', border: '1px solid #eee', borderRadius: 6 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={th}>Registered for</th>
                <th style={th}>Division</th>
                <th style={th}>Type</th>
                <th style={th}>Payment</th>
                <th style={th}>Registered</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const colour = CATEGORY_COLOURS[r.category] || CATEGORY_COLOURS.Other;
                const withdrawn = r.status === 'Withdrawn';
                return (
                  <tr key={r.id} style={{ borderTop: '1px solid #f0f0f0', opacity: withdrawn ? 0.55 : 1 }}>
                    <td style={td}>{r.competitionName}{withdrawn && <strong style={{ color: '#c62828', marginLeft: 6 }}>Withdrawn</strong>}</td>
                    <td style={td}>{r.divisionName || '–'}</td>
                    <td style={td}>
                      <span style={{ background: colour.bg, color: colour.fg, borderRadius: 999, padding: '1px 8px', fontWeight: 700, fontSize: '0.72rem' }}>{r.category}</span>
                    </td>
                    <td style={td}>{r.paymentStatus || '–'}</td>
                    <td style={td}>{r.registeredAt ? new Date(r.registeredAt).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) : '–'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const th = { textAlign: 'left', padding: '6px 8px', fontWeight: 700, color: '#333' };
const td = { padding: '6px 8px', verticalAlign: 'top' };
